// Convert price strings in either format into a dual-currency display:
//   FR style: "157 $", "~280 $", "157 $ visio · 206 $ présentiel"
//   EN style: "$157", "~$280", "$157 visio · $206 in-person"
// Output: "157 CAD / 115 USD" — preserves the leading "~" approximation marker.
const matchPrice = /(~?)(?:\$\s*(\d+)|(\d+)\s*\$)/g;

export const formatPriceCadUsd = (priceStr, cadToUsdRate) => {
  if (!priceStr) return priceStr;
  if (!cadToUsdRate) {
    // Until the live rate arrives, show only the CAD value (no USD yet).
    return priceStr.replace(matchPrice, (_m, tilde, n1, n2) => {
      const num = n1 || n2;
      return `${tilde}${num} CAD`;
    });
  }
  return priceStr.replace(matchPrice, (_m, tilde, n1, n2) => {
    const num = n1 || n2;
    const cad = parseInt(num, 10);
    const usd = Math.round(cad * cadToUsdRate);
    return `${tilde}${cad} CAD / ${tilde}${usd} USD`;
  });
};
